import { render, staticRenderFns } from "./emitFacefilter.vue?vue&type=template&id=754d8945&scoped=true"
import script from "./emitFacefilter.vue?vue&type=script&lang=js"
export * from "./emitFacefilter.vue?vue&type=script&lang=js"
import style0 from "./emitFacefilter.vue?vue&type=style&index=0&id=754d8945&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754d8945",
  null
  
)

export default component.exports